import { localize } from "render/context/InternationalizationContext";

const Header = localize({
  en_GB: "Book a Neko Body Scan",
  sv_SE: "Boka en Neko Body Scan",
});
const Location = localize<{ count: number | undefined }>({
  en_GB: ({ count }) => (
    <>STOCKHOLM {count != null && <>[{count} centers]</>}</>
  ),
  sv_SE: ({ count }) => <>STOCKHOLM {count != null && <>[{count} center]</>}</>,
});
const AllLocationsFilter = localize({
  en_GB: "Any Health centre",
  sv_SE: "Alla Hälsocenter",
});

export const Trans = {
  Header,
  Location,
  AllLocationsFilter,
};
